import { clsx } from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'

type ProductSearchResultItemGenericLabelProps =
  ComponentPropsWithoutRef<'button'> & {
    hasBorder?: boolean
  }

export const ProductSearchResultItemGenericLabel: FC<
  ProductSearchResultItemGenericLabelProps
> = ({ className, hasBorder = true, ...rest }) => (
  <button
    className={clsx(
      className,
      'flex items-center whitespace-nowrap rounded-full border px-3 py-1 text-xs',
      !hasBorder && 'border-transparent',
      !rest.onClick && 'cursor-default',
    )}
    type="button"
    {...rest}
  />
)
